export default __webpack_public_path__ + "static/media/a038-2.3108126d.svg";